import { useMemo } from "react";
import { Autocomplete, TextField, CircularProgress } from "@mui/material";
import { useGetActionHistoryQuery } from "../Api/Queries/useGetActionHistoryQuery";
import { ActionHistoryDto } from "Infrastructure/Api/Api";
import { ActionType } from "Infrastructure/Api/ApiCustom";
import { formatDateLeadingZeroes } from "Infrastructure/Utils/DateUtils";
import { getActionTypeDescription } from "Infrastructure/Utils/Nsure/DeviceUtils";

export interface ActionHistorySelectProps {
	actionTypes: ActionType[];
	onSelect: (action: ActionHistoryDto | null) => void;
	value: ActionHistoryDto | null;
	label?: string;
	disabled?: boolean;
	device?: string;
}

export function ActionHistorySelect({
	actionTypes,
	onSelect,
	value,
	label = "Historická akce",
	disabled = false,
	device,
}: ActionHistorySelectProps) {
	const typesString = useMemo(() => actionTypes.join(";"), [actionTypes]);
	const { data, isLoading } = useGetActionHistoryQuery(
		0,
		100,
		typesString,
		device
	);
	const items: ActionHistoryDto[] =
		data && data.status === 200 && (data.data as any)?.items
			? (data.data as any).items
			: [];

	return (
		<Autocomplete
			size="small"
			fullWidth
			options={items}
			value={value}
			onChange={(_event, newValue) => onSelect(newValue)}
			getOptionLabel={(option) =>
				option
					? `[${option.requestID}] ${formatDateLeadingZeroes(
							new Date(option.dateCreated)
					  )} | ${getActionTypeDescription(option.actionType, true)}, ${option.createdByName ?? ""}`
					: ""
			}
			isOptionEqualToValue={(option, val) => option.actionID === val?.actionID}
			loading={isLoading}
			disabled={disabled || isLoading}
			clearOnEscape
			noOptionsText="Žádné možnosti"
			renderInput={(params) => (
				<TextField
					{...params}
					label={label}
					InputProps={{
						...params.InputProps,
						endAdornment: (
							<>
								{isLoading ? (
									<CircularProgress color="inherit" size={20} />
								) : null}
								{params.InputProps.endAdornment}
							</>
						),
					}}
				/>
			)}
		/>
	);
}
